/**
 * MY — Exempt Private Company Certificate (Section 260 & 261, M32016) Register Detail 매핑.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('M32016', {
  title: 'Exempt Private Company Certificate Details',
  fields: [
    { label: 'Company Name', key: ['entityName', 'companyName', 'company_name', 'presetForm.companyName', 'presetForm.state.values.company_name'] },
    { label: 'Registration No.', key: ['entityRegNo', 'companyRegistrationNo', 'presetForm.companyRegistrationNo', 'presetForm.state.values.company_registration_no'] },
    { label: 'FS Made Up To', key: ['presetForm.fsMadeUpTo', 'presetForm.state.values.fs_made_up_to', 'fs_made_up_to'] },
    { label: 'Circulation Date', key: ['presetForm.circulationDate', 'presetForm.state.values.circulation_date', 'circulation_date'] },
    { label: 'Certification Date', key: ['presetForm.certificationDate', 'presetForm.state.values.certification_date', 'certification_date'] },
    { label: 'Director Name', key: ['presetForm.directorName', 'presetForm.state.values.director_name', 'director_name'] },
    { label: 'Secretary Name', key: ['presetForm.secretaryName', 'presetForm.state.values.secretary_name', 'secretary_name'] },
    { label: 'Auditor Name', key: ['presetForm.auditorName', 'presetForm.state.values.auditor_name', 'auditor_name'] },
  ],
});
